import React from 'react';
import styles from './sponsors.module.css';
import { NavLink } from "react-router-dom";
 const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
const Sponsors = () => {
  return (
    <section className={styles.sponsorspage} id="sponsors">
      <div className={styles.sponsorscontainer}>
        
        <header className={styles.sponsorshero}>
          <p className={styles.eyebrow}>TEDxIITGuwahati</p>
          
          <p className={styles.subtitle}>
            TEDxIITGuwahati is made possible by the generous support of our partners who believe in ideas worth spreading.
          </p>
        </header>

        <section className={styles.sponsorcta}>
          <h2>Partner with TEDxIITGuwahati</h2>
          <p>
            We're looking for a select group of strategic partners to help us grow the impact of TEDxIITGuwahati over the next five years to help us reach 100,000+ Guwahatians through our live in-person events and 100+ million global citizens through our virtual events and videos.
          </p>
          <a href="mailto:iitg.tedx@gmail.com" className={styles.ctabutton}>Sponsor TEDxIITGuwahati</a>
        </section>
        
        
        <section className={styles.sponsorcontentsection}>
          <h2>Why Partner with us?</h2>
          <div className={styles.partnerbenefits}>
            <div className={styles.benefitcard}>
              <h3>🎯 Influential Audience</h3>
              <p>Connect your brand with the most influential audience in the Washington DC metropolitan area - dreamers, doers, influencers.</p>
            </div>
            <div className={styles.benefitcard}>
              <h3>✨ Brand Alignment</h3>
              <p>Align your brand with TEDxIITGuwahati and our mission to spread ideas, build community, and change lives.</p>
            </div>
            <div className={styles.benefitcard}>
              <h3>📈 Corporate Objectives </h3>
              <p>Achieve specific corporate objectives with our customized and integrated approach to partnerships.</p>
            </div>
            <div className={styles.benefitcard}>
              <h3>💡 Thought Leadership</h3>
              <p>Be a leader in bringing together corporations, start-ups, entrepreneurs, and individuals who are inspired by remarkable thinking.</p>
            </div>
          </div>
        </section>

        
        <section className={styles.sponsorcontentsection}>
          <h2>Our Audience</h2>
          <p>
              Since 2019, TEDxIITGuwahati has been working to galvanize the local community, bringing together corporations, community organizations, entrepreneurs, and individuals, providing a platform for exceptional ideas, and a catalyst for profound change.
          </p>
          <div className={styles.audiencestats}>
            <div className={styles.statbox}>
              <h3>1000+</h3>
              <p>Attendees </p>
            </div>
            <div className={styles.statbox}>
              <h3>1.5K+</h3>
              <p>SOCIAL REACH</p>
            </div>
           <div className={styles.statbox}>
              <h3>1M+</h3>
              <p>YOUTUBE VIEWS</p>
            </div>
            <div className={styles.statbox}>
              <h3>7K+</h3>
              <p>IMPRESSIONS</p>
            </div>
          </div>
        </section>

        
        <section className={styles.sponsorcontentsection}>
          <h2>Sponsorship Opportunities</h2>
          <p>
            Below are just a few of this year's sponsorship opportunities.
          </p>
          <div className={styles.opportunitygrid}>
            <div className={styles.opportunitycard}>
              <h3>ALL YEAR ROUND</h3>
              <p>Executive Committee</p>
              <p>Host Committee</p>
              <p>Special Events</p>
              <p>Sustainability Partner</p>
            </div>
            <div className={styles.opportunitycard}>
              <h3>LIVE CONFERENCES</h3>
              <p>Global Partner</p>
              <p>Tech Lounge Host</p>
              <p>Connection Cafe Host</p>
              <p>After Party Host</p>
            </div>
            <div className={styles.opportunitycard}>
              <h3>IN-KIND SUPPORT</h3>
              <p>Media Partner</p>
              <p>Marketing PR Partner</p>
              <p>Co-Working Partner</p>
              <p>Printing Partner</p>
            </div>
          </div>
          
           <NavLink to="/ContactUs"onClick={scrollToTop}  className={styles.secondarycta}>Contact Us</NavLink>
        </section>

    
        <section className={styles.pastsponsorssection}>
          <h2>Previous Partners</h2>
          <p>We are thankful for the support of our past sponsors who made our previous editions a great success.</p>
          <div className={styles.pastsponsorsgrid}>
            <div className={styles.logocard}>
              <img src="./images/sponsors/bigfm.jpeg"></img>
            </div>
            <div className={styles.logocard}>
              <img src="./images/sponsors/eastern chronicle.jpeg"></img>
            </div>
            <div className={styles.logocard}>
              <img src="./images/sponsors/startupnews.jpeg"></img>
            </div>
            <div className={styles.logocard}>
              <img src="./images/sponsors/devilsburger.png"></img>
            </div>
            <div className={styles.logocard}>
              <img src="./images/sponsors/easemytrip.png"></img>
            </div>
             <div className={styles.logocard}>
              <img src="./images/sponsors/gplus.png"></img>
            </div>
             <div className={styles.logocard}>
              <img src="./images/sponsors/justassamthings.png"></img>
            </div>
            <div className={styles.logocard}>
              <img src="./images/sponsors/swaglok.png"></img>
              
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Sponsors;